module.exports = __webpack_public_path__ + "img/ic_tripadvisor-2.0.94db3b93.svg";